export const DEFAULT_DATE_FORMAT = "DD/MM/YYYY"
export const PARTIAL_DATE_FORMAT = "YYYY-MM-DD"